import { useSession } from 'next-auth/react';
import { Prisma } from '@prisma/client';
import { fetchWithToken } from '../../helpers/fetchWithToken';
import { useQuery } from '@tanstack/react-query';

const userWithTeams = Prisma.validator<Prisma.UserArgs>()({
  include: { teams: { include: { team: true } } },
});

export type UserWithTeams = Prisma.UserGetPayload<typeof userWithTeams>;

export default function useUser(): {
  user: UserWithTeams | null;
  isLoading: boolean;
  isError: boolean;
} {
  const { data: session } = useSession();

  const query = useQuery<UserWithTeams>(
    ['me'],
    () => fetchWithToken('/auth/me', session?.accessToken as string),
    {
      enabled: !!session?.accessToken,
    },
  );

  return {
    user: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
